/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { MdLibraryAdd } from "react-icons/md";
import { apiPath, RoutePath } from "../../utility/Constant";
import { deleteData } from "../../hooks/delete";
import { useState } from "react";

const CSRHighlightCard = ({ project, user }) => {
  const [hidden, setHidden] = useState(false);
  const { addCsrHighlights } = RoutePath;
  const { CSRApi } = apiPath;
  const handleDelete = (event) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteData(`${CSRApi}/${event.target.id}`);
        setTimeout(() => {
          setHidden(true);
        }, 1000);
      }
    });
  };

  return (
    <div className={hidden && "hidden"}>
      {project ? (
        <div className="card bg-base-100 shadow-xl h-[20rem] rounded-md">
          <div className="p-4 h-full flex flex-col justify-between">
            <h2 className="text-xl h-12 flex items-center justify-center text-center uppercase font-semibold">
              {project.highlightTitle}
            </h2>

            <p>{project.highlightDescription}</p>

            <div className="card-actions justify-between">
              <Link
                to={`/csr/highlights/${project._id}`}
                className="btn btn-outline btn-xs border-blue-500 text-blue-500 hover:bg-blue-500 hover:border-blue-500 hover:text-white rounded-md h-8 "
              >
                Edit
              </Link>
              {user === "admin" && (
                <button
                  id={project._id}
                  onClick={handleDelete}
                  className="btn btn-outline btn-xs border-red-500 text-red-500 hover:bg-red-500 hover:border-red-500 hover:text-white rounded-md h-8 "
                >
                  Delete
                </button>
              )}
            </div>
          </div>
        </div>
      ) : (
        <Link
          to={`/${addCsrHighlights}`}
          className="flex justify-center items-center rounded-xl bg-gray-50 shadow-xl h-full "
        >
          <p className="text-8xl">
            <MdLibraryAdd />
          </p>
        </Link>
      )}
    </div>
  );
};

export default CSRHighlightCard;
